/* eslint-disable jsx-a11y/anchor-is-valid */
// client/src/components/dashboard/sidebar/Sidebar.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaUser, FaCogs, FaShoppingBag, FaSignOutAlt, FaHome, FaInfoCircle, FaChevronDown, FaChevronUp, FaBlog, FaEnvelope, FaCog, FaRegLightbulb } from 'react-icons/fa';
import { RiHomeWifiLine } from 'react-icons/ri';
import { useAuth } from '../../../context/AuthContext'; // Import useAuth
import { useTranslation } from 'react-i18next';

import './Sidebar.css';

function Sidebar({ onSectionChange, activeSection }) { // Receive props
    const { logout } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [dropdownOpen, setDropdownOpen] = useState(false);


    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    }

    return (
        <div className="sidebar">
            <div className="sidebar-logo">
                <Link to="/">
                    <FaHome className="sidebar-icon" />
                    {t('header.beinSmart')}</Link>
            </div>
            <nav className="sidebar-nav">
                <ul>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('dashboard'); }}
                            className={activeSection === 'dashboard' ? 'active-link' : ''}>
                            <FaTachometerAlt className="sidebar-icon" />
                            <span>{t('dashboard.dashboardTab')}</span> {/* Translate */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('account'); }}
                            className={activeSection === 'account' ? 'active-link' : ''}>
                            <FaUser className="sidebar-icon" />
                            <span>{t('dashboard.accountTab')}</span> {/* Use new translation key */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('properties');}}
                           className={activeSection === 'properties' ? 'active-link' : ''}>
                            <RiHomeWifiLine className="sidebar-icon" /> {/*  Option 1: Wi-Fi Home */}
                            <span>{t('dashboard.manageProperties')}</span>
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('devices');}}
                           className={activeSection === 'devices' ? 'active-link' : ''}>
                            <FaRegLightbulb className="sidebar-icon" />
                            <span>{t('dashboard.manageDevices', 'Manage Devices')}</span> {/* Add translation key */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('settings'); }}
                           className={activeSection === 'settings' ? 'active-link' : ''}>
                            <FaCog className="sidebar-icon" /> {/* Settings icon */}
                            <span>{t('dashboard.settingsTab')}</span> {/* Translate */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('services'); }}
                            className={activeSection === 'services' ? 'active-link' : ''}>
                            <FaCogs className="sidebar-icon" />
                            <span>{t('dashboard.servicesTab')}</span> {/* Translate */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('products'); }}
                            className={activeSection === 'products' ? 'active-link' : ''}>
                            <FaShoppingBag className="sidebar-icon" />
                            <span>{t('dashboard.productsTab')}</span> {/* Translate */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('blog'); }}
                            className={activeSection === 'blog' ? 'active-link' : ''}>
                            <FaBlog className="sidebar-icon" /> {/* Add Blog icon */}
                            <span>{t('header.blog')}</span> {/*Use existing translation*/}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('about'); }}
                            className={activeSection === 'about' ? 'active-link' : ''}>
                            <FaInfoCircle className="sidebar-icon" /> {/* Icon for About Us */}
                            <span>{t('header.aboutUs')}</span> {/* Use existing translation */}
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('contact'); }}
                            className={activeSection === 'contact' ? 'active-link' : ''}>
                            <FaEnvelope className="sidebar-icon" /> {/* Add Contact icon */}
                            <span>{t('header.contact')}</span> {/* Use existing translation */}
                        </a>
                    </li>
                    <li>
                        <div className="sidebar-dropdown">
                            <a href="#" onClick={(e) => { e.preventDefault(); toggleDropdown(); }} className={dropdownOpen ? 'active-link' : ''}>
                                {dropdownOpen ? <FaChevronUp className="sidebar-icon" /> : <FaChevronDown className="sidebar-icon" />}
                                <span>{t('dashboard.legalPrivacy')}</span> {/* Add translation key */}
                            </a>
                            {dropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li>
                                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('privacy'); }}>{t('Register.privacyPolicy')}</a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('cookies'); }}>{t('Register.cookiesPolicy')}</a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={(e) => { e.preventDefault(); onSectionChange('agreement'); }}>{t('Register.userAgreement')}</a>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </li>
                    <li className="logout-link-container">
                        <button onClick={handleLogout} className="logout-button">
                            <FaSignOutAlt className="sidebar-icon" />
                            <span>{t('dashboard.logout')}</span> {/* Translate */}
                        </button>
                    </li>
                    {/* Copyright Notice */}
                    {/* <div className={`copyright ${i18n.language === 'ar' ? 'rtl' : ''}`}>
                        &copy; {new Date().getFullYear()} beinSmart.cloud. {t('footer.allRightsReserved')}
                    </div> */}
                </ul>
            </nav>
        </div>
    );
}

export default Sidebar;